import {
  ALBUM,
  BASE_URL,
  POSTER_URL,
  SECTION_ONE_VIDEO_URL,
  type AlbumName,
} from './core';
import {
  BRAND_TITLE_HE,
  BRAND_TITLE_SHORT,
  HOME_DESC,
  HOME_HERO_TITLE,
  WORDS,
} from '../i18n/locales/i18n.he';

export type GalleryVideoSeoItem = {
  id: string;
  albumName: AlbumName | 'בית';
  pageLoc: string;
  contentUrl: string;
  thumbnailUrl: string;
  title: string;
  description: string;
  uploadDate: string;
  durationSeconds: number;
  tags: readonly string[];
};

const siteRoot = `${BASE_URL}/`;
const galleryPage = siteRoot;
const uploadDate = '2026-06-17T08:00:00+03:00';

export const galleryVideoSeoItems = [
  {
    id: 'home-hero',
    albumName: 'בית',
    pageLoc: siteRoot,
    contentUrl: SECTION_ONE_VIDEO_URL,
    thumbnailUrl: POSTER_URL,
    title: HOME_HERO_TITLE,
    description: HOME_DESC,
    uploadDate: '2025-01-14T08:00:00+03:00',
    durationSeconds: 30,
    tags: [
      WORDS.dj.he_alt,
      WORDS.mc,
      WORDS.events.wedding.one,
      WORDS.events.henna.one,
      WORDS.events.bar_bat.one,
      BRAND_TITLE_SHORT,
    ],
  },
  {
    id: 'wedding-gallery',
    albumName: ALBUM.weddings,
    pageLoc: galleryPage,
    contentUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/חתונות/תקליטן לחתונות - די ג׳יי אליאור מור 78.mp4',
    thumbnailUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/חתונות/תקליטן לחתונות - די ג׳יי אליאור מור 01.webp',
    title: `${BRAND_TITLE_HE} - סרטון חתונה מהרחבה`,
    description:
      'סרטון חתונה אמיתי מהגלריה של די ג׳יי אליאור מור: רחבה מלאה, מוזיקה מדויקת וקריאת קהל לאורך הערב.',
    uploadDate,
    durationSeconds: 30,
    tags: ['דיג׳יי לחתונה', 'תקליטן לחתונה', 'חתונה', BRAND_TITLE_SHORT],
  },
  {
    id: 'wedding-gallery-secondary',
    albumName: ALBUM.weddings,
    pageLoc: galleryPage,
    contentUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/חתונות/תקליטן לחתונות - די ג׳יי אליאור מור 66.mp4',
    thumbnailUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/חתונות/תקליטן לחתונות - די ג׳יי אליאור מור 01.webp',
    title: `${BRAND_TITLE_HE} - סרטון חתונה נוסף מהגלריה`,
    description:
      'סרטון חתונה נוסף מהגלריה של די ג׳יי אליאור מור: אנרגיה ברחבה, מעברים מדויקים ואווירה שמחה לאורך האירוע.',
    uploadDate,
    durationSeconds: 30,
    tags: ['דיג׳יי לחתונות', 'תקליטן לחתונות', 'חתונות', BRAND_TITLE_SHORT],
  },
  {
    id: 'henna-gallery',
    albumName: ALBUM.hennas,
    pageLoc: galleryPage,
    contentUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/חינות/תקליטן לחינות - די ג׳יי אליאור מור 25.mp4',
    thumbnailUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/חינות/תקליטן לחינות - די ג׳יי אליאור מור 01.webp',
    title: `${BRAND_TITLE_HE} - סרטון חינה מהגלריה`,
    description:
      'סרטון חינה אמיתי מהגלריה של די ג׳יי אליאור מור: צבע, מעגלים, מוזיקה מזרחית ואנרגיה משפחתית ברחבה.',
    uploadDate,
    durationSeconds: 30,
    tags: ['דיג׳יי לחינה', 'תקליטן לחינה', 'חינה', BRAND_TITLE_SHORT],
  },
  {
    id: 'henna-gallery-secondary',
    albumName: ALBUM.hennas,
    pageLoc: galleryPage,
    contentUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/חינות/תקליטן לחינות - די ג׳יי אליאור מור 26.mp4',
    thumbnailUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/חינות/תקליטן לחינות - די ג׳יי אליאור מור 01.webp',
    title: `${BRAND_TITLE_HE} - סרטון חינה נוסף מהגלריה`,
    description:
      'סרטון חינה נוסף מהגלריה של די ג׳יי אליאור מור: רגעים מהטקס, מעגלים, צבע ואנרגיה משפחתית ברחבה.',
    uploadDate,
    durationSeconds: 30,
    tags: ['דיג׳יי לחינות', 'תקליטן לחינות', 'חינות', BRAND_TITLE_SHORT],
  },
  {
    id: 'bar-bat-gallery',
    albumName: ALBUM.barBat,
    pageLoc: galleryPage,
    contentUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/בר מצוות/תקליטן לבר מצוות - די ג׳יי אליאור מור 37.mp4',
    thumbnailUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/בר מצוות/תקליטן לבר מצוות - די ג׳יי אליאור מור 01.webp',
    title: `${BRAND_TITLE_HE} - סרטון בר/בת מצווה מהגלריה`,
    description:
      'סרטון בר/בת מצווה מהגלריה של די ג׳יי אליאור מור: קהל צעיר ומשפחות, מוזיקה שמחה ורחבה פעילה.',
    uploadDate,
    durationSeconds: 30,
    tags: ['דיג׳יי לבר מצווה', 'תקליטן לבר מצווה', 'בר/בת מצווה', BRAND_TITLE_SHORT],
  },
  {
    id: 'bar-bat-gallery-secondary',
    albumName: ALBUM.barBat,
    pageLoc: galleryPage,
    contentUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/בר מצוות/תקליטן לבר מצוות - די ג׳יי אליאור מור 54.mp4',
    thumbnailUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/בר מצוות/תקליטן לבר מצוות - די ג׳יי אליאור מור 01.webp',
    title: `${BRAND_TITLE_HE} - סרטון בר/בת מצווה נוסף מהגלריה`,
    description:
      'סרטון בר/בת מצווה נוסף מהגלריה של די ג׳יי אליאור מור: רחבה צעירה, משפחות, קצב שמח ואווירה פעילה.',
    uploadDate,
    durationSeconds: 30,
    tags: ['דיג׳יי לבר/בת מצווה', 'תקליטן לבר/בת מצווה', 'בר/בת מצווה', BRAND_TITLE_SHORT],
  },
  {
    id: 'recommendations-gallery',
    albumName: ALBUM.recommendations,
    pageLoc: galleryPage,
    contentUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/המלצות/המלצת לקוח די ג׳יי אליאור מור 16.mp4',
    thumbnailUrl:
      'https://djeliormorbucket.s3.eu-central-1.amazonaws.com/Gallery/המלצות/המלצת לקוח די ג׳יי אליאור מור 01.webp',
    title: `${BRAND_TITLE_HE} - המלצת לקוח בוידאו`,
    description:
      'המלצת לקוח בוידאו מתוך גלריית ההמלצות של די ג׳יי אליאור מור, עם חוויה אמיתית מאירוע.',
    uploadDate,
    durationSeconds: 30,
    tags: ['המלצות דיג׳יי', 'די ג׳יי מומלץ', 'לקוחות ממליצים', BRAND_TITLE_SHORT],
  },
] as const satisfies readonly GalleryVideoSeoItem[];

export function durationToIso8601(seconds: number) {
  return `PT${Math.max(1, Math.floor(seconds))}S`;
}

export function toSeoUrl(url: string) {
  const raw = String(url ?? '').trim();
  try {
    return encodeURI(decodeURI(raw));
  } catch {
    return encodeURI(raw);
  }
}

export function getGalleryVideosForTopic(topic: string, limit = 2): GalleryVideoSeoItem[] {
  const text = String(topic ?? '');
  const isRelevantTopic = /אליאור|אירוע|חתונה|חינה|מצווה|דיג׳יי|די ג׳יי|תקליטן/.test(text);

  if (!isRelevantTopic) return [];

  if (/חתונ/.test(text)) {
    return galleryVideoSeoItems
      .filter((item) => item.id !== 'home-hero' && item.albumName === ALBUM.weddings)
      .slice(0, limit) as GalleryVideoSeoItem[];
  }

  if (/חינ/.test(text)) {
    return galleryVideoSeoItems
      .filter((item) => item.id !== 'home-hero' && item.albumName === ALBUM.hennas)
      .slice(0, limit) as GalleryVideoSeoItem[];
  }

  if (/בר\/בת|בר מצווה|בת מצווה/.test(text)) {
    return galleryVideoSeoItems
      .filter((item) => item.id !== 'home-hero' && item.albumName === ALBUM.barBat)
      .slice(0, limit) as GalleryVideoSeoItem[];
  }

  const preferred: AlbumName[] =
    [ALBUM.weddings, ALBUM.hennas, ALBUM.barBat, ALBUM.recommendations];

  const selected: GalleryVideoSeoItem[] = [];

  for (const albumName of preferred) {
    const item = galleryVideoSeoItems.find(
      (video) => video.id !== 'home-hero' && video.albumName === albumName
    );
    if (item) selected.push(item);
    if (selected.length >= limit) break;
  }

  return selected;
}
